import { render, staticRenderFns } from "./ModificaVariante.vue?vue&type=template&id=5041e178&"
import script from "./ModificaVariante.vue?vue&type=script&lang=js&"
export * from "./ModificaVariante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports